export const technicalInfo = '/technicalInfo'